import { QueryKey } from '@tanstack/react-query';

import { Issuer } from '@arrived/models';

export const issuersQueryKey: QueryKey = ['issuers'];
export const issuerQueryKey: (issuerId: Issuer['id']) => QueryKey = (issuerId) => issuersQueryKey.concat(issuerId);
